import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface CancelOrConfirmDialogProps {
  title: string;
  contentText: string | JSX.Element;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  cancelText?: string;
  confirmText?: string;
  children?: string | JSX.Element | JSX.Element[];
}

export default function CancelOrConfirmDialog(props: CancelOrConfirmDialogProps) {
  const { title, contentText, open, onClose, onConfirm, cancelText, confirmText, children } = props;

  return (
    <Dialog
      open={open}
      onClose={(event: React.SyntheticEvent, reason: string) => {
        if (reason === 'escapeKeyDown') {
          onClose();
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ fontSize: 18, fontWeight: 600 }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" sx={{ fontSize: 14 }}>
          {contentText}
        </DialogContentText>
        {children}
      </DialogContent>
      <DialogActions sx={{ display: 'flex', gap: 1, p: 3, borderTop: 1, borderTopColor: '#E4E4E4' }}>
        <Button
          variant="secondary"
          onClick={() => {
            onClose();
          }}
        >
          {cancelText || 'Não'}
        </Button>
        <Button variant="primary" onClick={() => onConfirm()} autoFocus>
          {confirmText || 'Sim'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
